module.exports = __webpack_public_path__ + "static/img/Dan_Hannebery_mobile.bfa0bef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dan_Hannebery_mobile.jpg
// module id = GLMl
// module chunks = 0